
define('ldsh!modules/form_editor/templates/editor_custom_month_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="flex align-center gap-8">\n\t<input type="text" class="ed-form-control js-text" value="' +
((__t = ( monthName )) == null ? '' : __t) +
'">\n\t<span class="flex align-center gap-4">\n\t\t<button\n\t\t\ttype="button"\n\t\t\tclass="btn--rounded btn--ghost js-toggle-value"\n\t\t\tdata-i18n="[title]formEditor.toolbar.editValue"\n\t\t>\n\t\t\t<span class="ri-code-s-slash-fill"></span>\n\t\t</button>\n\t\t<button\n\t\t\ttype="button"\n\t\t\tclass="btn--rounded btn--ghost js-add"\n\t\t\tdata-i18n="[title]formEditor.toolbar.addItem"\n\t\t>\n\t\t\t<span class="ri-add-line"></span>\n\t\t</button>\n\t\t<button\n\t\t\ttype="button"\n\t\t\tclass="btn--rounded btn--ghost js-remove"\n\t\t\tdata-i18n="[title]formEditor.toolbar.removeItem"\n\t\t>\n\t\t\t<span class="ri-delete-bin-6-line"></span>\n\t\t</button>\n\t</span>\n</div>\n\n<p class="ed-input-value ed-form-group-row hidden js-item-value">\n\t<span class="ed-value-label" data-i18n="formEditor.dropDownItemValue">Valor</span>\n\t<input type="text" value="' +
((__t = ( value || monthName )) == null ? '' : __t) +
'" class="ed-form-control js-value-text">\n</p>\n';

}
return __p
};});

